import { observer } from 'mobx-react-lite'
import { PageLayout } from '@/features/jobs/details/components/PageLayout'
import type { JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { DocumentsSectionContainer } from '@/features/jobs/details/components/DocumentsSection'
import { useActivation } from '@/hooks/view-model-hooks'
import { TranscriptDownloadSectionContainer } from '@/features/jobs/details/consultation/components/TranscriptDownloadSection'
import type { ConsultationJobDetailsViewModel } from '@/features/jobs/details/consultation-type/ConsultationJobDetailsViewModel'

interface ConsultationDocsTabProps {
  vm: JobDetailsViewModel
}

/**
 * Consultation-specific docs tab.
 */
export default observer(function ConsultationDocsTab({
  vm,
}: ConsultationDocsTabProps) {
  useActivation(vm.docsVm)

  // We know this is safe.
  const typeVm = vm.typeVm as ConsultationJobDetailsViewModel
  const consultationManagerVm = typeVm.consultationManagerVm
  return (
    <>
      <PageLayout
        asideTop={
          <TranscriptDownloadSectionContainer vm={consultationManagerVm} />
        }
      >
        <DocumentsSectionContainer vm={vm} />
      </PageLayout>
    </>
  )
})
